<template>
  <div class="rhlistDrawer">
    <Modal
      class="common-drawer newModal"
      v-model="showInDrawer"
      :title="title"
      width="480px"
      :mask-closable="false"
      @on-cancel="dwcloseDrawer()"
      class-name="vertical-center-modal"
    >
      <Form
        ref="formValidate"
        :model="formData"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem label="油品名称" prop="name">
          <Input v-model="formData.name" placeholder="请输入" />
        </FormItem>

        <FormItem label="油品类型" prop="item">
          <Input v-model="formData.item" placeholder="请输入" />
        </FormItem>

        <FormItem label="油品品牌" prop="brandId">
          <Row>
            <Col span="22">
              <Select
                :clearable="brandIdSble"
                ref="brandIdBo"
                v-model="formData.brandId"
                placeholder="请选择"
                style="width: 390px"
              >
                <Option
                  :value="brand.id"
                  v-for="brand in dataCenter.brand"
                  :key="brand.id"
                  >{{ brand.value }}
                </Option>
              </Select>
            </Col>
            <Col class="lan" span="2">
              <div @click="oilbrandPop = true">编辑</div>
            </Col>
          </Row>

          <!-- <Icon @click="oilbrandPop=true" type="ios-add-circle" class="addOilIcon success" /> -->
        </FormItem>
      </Form>
      <div class="drawer-footer" slot="footer">
        <Button
          type="primary"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="rest()">取消</Button>
      </div>
    </Modal>

    <OilbrandModal
      ref="oilModal"
      :oilbrandPop.sync="oilbrandPop"
      :closePop="closePop"
      @setBrandId="setBrandId"
      :refreshOilBrand="refreshOilBrand"
    >
    </OilbrandModal>
  </div>
</template>

<script>
import api from "@/api";
import ls from "store2";
import OilbrandModal from "./oilbrand-modal";
export default {
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
    refreshOilBrand: Function,
  },
  components: {
    OilbrandModal,
  },
  data() {
    return {
      brandIdSble: false,
      oilbrandPop: false,
      showInDrawer: false,
      formData: {
        name: "",
        item: "",
        brandId: "",
      },
      title: "",
      btnLoading: false,
      ruleValidate: {
        name: [
          {
            required: true,
            message: "请填写油品名称",
            trigger: "blur",
          },
        ],
        item: [
          {
            required: true,
            message: "请填写油品类型",
            trigger: "blur",
          },
        ],
        brandId: [
          {
            required: true,
            message: "请选择油品品牌",
            trigger: "change",
          },
        ],
      },
    };
  },
  mounted() {},
  methods: {
    cleartRest() {
      let t = setTimeout(() => {
        console.log("我清空了");
        this.brandIdSble = true;

        this.$nextTick(async () => {
          this.$refs["brandIdBo"].clearSingleSelect();

          let t1 = setTimeout(() => {
            this.brandIdSble = false;
            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },
    dwcloseDrawer() {
      this.closeDrawer();
      this.$nextTick(async () => {
        this.cleartRest();
      });
    },
    rest() {
      this.getLists();

      this.dwcloseDrawer();
    },
    submitForm(name) {
      // if (!this.formData.name) return this.$Message.info("请填写油品名称");
      // if (!this.formData.item) return this.$Message.info("请填写油品类型");
      // if (!this.formData.brandId) return this.$Message.info("请选择油品品牌");

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.btnLoading = true;
          api
            .axss("post", "/ocm-oil-site/oil-product/edit", this.formData)
            .then((res) => {
              if (res.code === "00000") {
                this.$Message.success("提交成功");
                this.btnLoading = false;
                this.dwcloseDrawer(); // 关闭弹窗
                this.getLists(); // 刷新列表
              }
            })
            .catch((error) => {
              this.btnLoading = false;
            });
        }
      });
    },
    setBrandId(bid) {
      this.formData.brandId = bid;
    },
    closePop() {
      this.oilbrandPop = false;
    },
    reset(key) {
      Object.keys(this[key]).forEach((item) => {
        this[key][item] = "";
      });
    },
  },
  watch: {
    curItemDetail: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) this.$refs.formValidate.resetFields();
        if (newValue.id) this.formData = newValue;
        else this.formData = {};

        if (newValue.brandId) {
          this.title = "修改油品";
        } else {
          this.title = "新增油品";
        }
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        this.showInDrawer = newValue;
      },
      deep: true,
    },
  },
};
</script>

<style lang='less'>
.rhlistDrawer {
}

.addOilIcon {
  font-size: 30px;
  vertical-align: middle;
  cursor: pointer;
  margin-left: 10px;
}
.lan {
  color: rgb(12, 71, 157);
  cursor: pointer;
}
</style>